module.exports = __webpack_public_path__ + "static/media/BoyLongHair.7659a339.svg";